import React, { useState, useEffect } from 'react';
import { isAuthenticated } from "../../../store/action/auth";
import { BarChart } from '../../../components/charts';
import { Loading } from '../../../components/loading';
import { getRatesUsage } from '../../../store/action/analytics';
import moment from 'moment';

export default function (props) {
    const { token, user } = isAuthenticated();
    const staticLines = [{
        value:50
    },{
        value:1000
    }]
    const [ data, setData ] = useState({
        data:[{
            date:moment().format("YYYY-MM-DD"),
            quantity:0
        }],
        show:false,
        loading:true
    });
    const [ date, setDate ] = useState({
        startDate:moment().add(-60,'days').format("YYYY-MM-DD"),
        endDate:moment().add(1,'days').format("YYYY-MM-DD"),
    })

    useEffect(() => {
        _fetchData();
    }, []);
        
    const _fetchData = async (sd,ed) => {
        const startDate = sd || date.startDate
        const endDate = ed || date.endDate

        getRatesUsage(`start_date=${startDate}&end_date=${endDate}&status=200&key_id=${props.match.params.key}`,token)
            .then(res => {
                console.log(res)
                if (!res.success){
                    setData({
                        ...data,
                        loading:false
                    })
                    return
                }
                const { data } = res;
            
                setData({
                    data:data,
                    show:true,
                    loading:false
                })
            })
            .catch(e => {
                setData({
                    ...data,
                    loading:false
                })
                return
            })
    }

    return (
        <div className="bg-white border-warning rounded shadow p-4">
            <div className=" d-flex justify-content-between">
                <h5>Penggunaan Kunci API </h5>
            </div>

            {
                data.loading ? 
                <Loading title="Memuat..."/>
                :
                <div>
                    <div className="mt-4">
                        <h6>Kunci API <text className="text-info">{props.match.params.key}</text></h6>
                    </div>
                    {
                        data.show ?
                            <BarChart
                                startDate={date.startDate}
                                startDate={date.endDate}
                                staticLines={staticLines}
                                data={data.data}
                            /> 
                            :
                            <div className="text-center p-4">
                                <h6>Belum ada data request</h6>
                            </div>
                    }
                   
                </div>
            }
        
        </div>
    )
}